import clsx from "clsx";
import React from "react";

interface IExpertiseAndExpericenceContent {
  title: string;
  description: string;
  image: string;
}

const ExpertiseAndExpericence: React.FC = () => {
  const content: IExpertiseAndExpericenceContent[] = [
    {
      title: "Recruitement and Manpower Consulting",
      description:
        "By helping organizations streamline their workforce, Dream Weavers will continue to provide employment opportunities and create a robust talent pool for multiple industries.",
      image: "/home/manpower.png",
    },
    {
      title: "Skill Development",
      description:
        "In partnership with government and private entities, Dream Weavers plans to widen its reach, bringing vocational training to more underserved areas and preparing India's youth for emerging job markets.",
      image: "/home/skill-development.png",
    },
    {
      title: "Corporate Training",
      description:
        " We design tailored programs to enhance employee skills, leadership, and performance. Covering technical skills, compliance, and soft skills. Our training programs boost engagement, productivity, and adaptability through workshops, e-learning, and on-the-job training.",
      image: "/home/corporate.png",
    },
    {
      title: "Tech-Based Tourism Solutions",
      description:
        "With advancements in technology, Dream Weavers envisions making its Tour Guide App a global benchmark for smart tourism, offering personalized, immersive experiences to travelers while contributing to local economies.",
      image: "/home/tourism.png",
    },
  ];
  return (
    <div className="w-full">
      <h3 className="text-xl font-medium sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3.2rem]">
        Our Expertise and Experience
      </h3>
      <div className="px-3 grid pt-5 lg:px-10 xl:pt-5 xl:px-12 sm:mt-5 sm:grid-cols-2 lg:grid-cols-4 gap-5 justify-center items-center">
        {content.map((item, index) => {
          return (
            <div
              className="sm:w-full w-72 h-[26rem] relative rounded-lg p-5  group hover:scale-[1.02] transition-all duration-300 ease-in-out hover:shadow-3xl"
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
              }}
              key={index}
            >
              <div className="text-white absolute z-[50]">
                <h4 className="text-lg text-with-shadow sm:text-xl lg:text-2xl font-medium max-w-[12rem]">
                  {item.title}
                </h4>
                <p className="text-xs sm:text-sm pr-3 text-with-shadow xl:text-[1rem] font-light">
                  {item.description}
                </p>
              </div>
              <div
                className={clsx(
                  "absolute inset-0 rounded-lg z-[10] bg-gradient-to-b via-transparent via-90% group-hover:bg-black/30 transition-all duration-300 ease-out",
                  {
                    "from-[#2E2F92]": index % 2 === 0,
                    "from-[#FF7E00]": index % 2 !== 0,
                  },
                )}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExpertiseAndExpericence;
